import { useEffect, useState } from 'react';
import Marquee from "react-fast-marquee";
// import {
//     motion,
//     useScroll,
//     useSpring,
//     useTransform,
//     useMotionValue,
//     useVelocity,
//     useAnimationFrame
//   } from "framer-motion";

export default function ProjectDetailsCarousell({
    gradientStart = "#FFCF51",
    gradientEnd = "#E6AB46",
    screenshots,
    isVertical = false,
}){

    const [ ready, setReady ] = useState(false);

    useEffect(() => {
        if(screenshots) if(screenshots.length > 0) setReady(true);
    }, [screenshots]);
    
    const verticalDivClass = `
        h-[300px]

        sm:h-[350px]

        md:h-[600px]

        lg:h-[700px]

        xl:h-[700px]
    `;


    const horizontalDivClass= `
        w-[400px]

        sm:min-w-[450px]

        md:min-w-[700px]

        lg:min-w-[800px]

        xl:min-w-[900px]
    `;


    // const baseSpeed = 500;



    if(ready){
        return(
            <>

                <div
                    className="
                        w-screen
                        h-[50svh]
                        md:h-screen
                        flex
                        items-center
                        justify-center
                    "
                    style={{
                        backgroundImage: `linear-gradient(to bottom, ${gradientStart}, ${gradientEnd})`,
                    }}
                >

                    <Marquee
                        speed={100}
                    >

                        {
                            screenshots.map((image, index) => {
                                return (
                                    <div
                                        key={"screenshot-" + index}
                                        className={
                                            (image.isVertical?verticalDivClass:horizontalDivClass) + 
                                            `
                                                mx-5
                                                sm:mx-10
                                            `
                                        }
                                    >
                                        <img 
                                            src={image.src}
                                            alt="Goods Screenshot"
                                            className={`
                                                object-contain
                                                ${
                                                    (image.isVertical?  ` h-full`:` w-full`)
                                                }
                                            `}
                                        />
                                    </div>
                                )
                            })
                        }


                    </Marquee>




                </div>


            </>
        );

    }

}